module.exports = __webpack_public_path__ + "img/pg4.d2869aec.png";